var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcSelect',{attrs:{"value":_vm.currentValue,"options":_vm.options,"track-by":"id","label":"text"},on:{"input":(newValue) => newValue !== null && _vm.$emit('input', newValue.id)}})
}
var staticRenderFns = []

export { render, staticRenderFns }